
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../services/firebase';
import { logger } from './logger';

export interface AuditLogEntry {
    userId: string;
    userEmail: string;
    role: string;
    action: string;
    details?: any;
    timestamp?: any;
    userAgent?: string;
}

export const logAudit = async (entry: Partial<AuditLogEntry> & { action: string }) => {
    try {
        const currentUser = auth.currentUser;
        
        const logData = {
            userId: entry.userId || currentUser?.uid || 'system',
            userEmail: entry.userEmail || currentUser?.email || 'system',
            role: entry.role || 'user',
            action: entry.action.toUpperCase(),
            details: entry.details || {},
            timestamp: serverTimestamp(),
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            url: window.location.href
        };

        await addDoc(collection(db, 'audit_logs'), logData);
    } catch (error) {
        logger.error("Falha ao registrar log de auditoria:", error);
    }
};
